import React from 'react';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { CoTravelerSummary, Traveler } from '@marageti/z4-sdk/lib/people';
import { SearchRequest, SearchResult } from '@marageti/z4-sdk/lib/entity';
import { Partner, TripRequest } from '@marageti/z4-sdk/lib/travel';
import { RoleName } from '@marageti/z4-sdk/lib/auth';
import { enqueueSnackbar } from 'notistack';
import View from './profile-view';
import { useTravelHistorySoldTrips, useTravelHistoryReviews } from '../../../components/travel-history-modal';
import { useAuthStore } from '../../../store';

const Container = () => {
  const { travelerId } = useParams();
  const { loggedInTeamMember } = useAuthStore();
  const canEdit = loggedInTeamMember?.userInfo?.[0].roles?.some(
    (role) => role === RoleName.ADMIN || role === RoleName.CARE,
  ) ?? false;
  const apiClient = useApiClient();
  const { data: traveler, mutate: mutateTraveler } = useFetch<Traveler>(apiClient.peopleClient.getTraveler, [travelerId], !!travelerId);

  const searchRequest: SearchRequest = {
    filterBy: [{ field: 'travelers.id', value: [travelerId!] }],
    pagination: { limit: 0, page: 1 },
  };
  const { data } = useFetch<SearchResult<TripRequest>>(apiClient.tripRequestsClient.postTripRequestSearches, [searchRequest], true);
  const { data: partner, mutate: mutatePartner } = useFetch<Partner>(apiClient.partnersClient.getPartner, [traveler?.referringPartnerId], !!traveler?.referringPartnerId);
  const { data: coTravelers } = useFetch<CoTravelerSummary[]>(apiClient.peopleClient.getTravelerCoTravelers, [travelerId], !!travelerId);

  const { totalHits: totalSoldTrips } = useTravelHistorySoldTrips(travelerId || '');
  const { totalHits: totalReviews } = useTravelHistoryReviews(travelerId || '');

  const handleEditAvatar = async (avatar: string) => {
    if (traveler) {
      try {
        const { avatar: updatedAvatar } = await apiClient.peopleClient.putTravelerAvatar(traveler.id, {
          id: traveler.id,
          avatar,
        });
        mutateTraveler({ ...traveler, avatar: updatedAvatar }, { revalidate: false });
      } catch (error) {
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      }
    }
  };

  return (
    <View
      travelerId={travelerId}
      canEdit={canEdit}
      onProfileEdit={mutatePartner}
      referringPartner={partner}
      traveler={traveler}
      totalTripRequests={data?.totalHits}
      totalSoldTrips={totalSoldTrips}
      totalReviews={totalReviews}
      coTravelers={coTravelers}
      onAvatarEdit={handleEditAvatar}
    />
  );
};

export default Container;
